import React, {useState, useEffect, useContext } from 'react';
import { IonModal, IonGrid, IonRow, IonCol, IonButton, IonSlides, IonSlide, IonContent, IonHeader, IonFooter, IonText } from '@ionic/react';

import { Auth_MerchantID_context } from '../../../../storeState/auth_merchantID_context';

import '../../../css/layout.css';
import { ViewAttachement_ImageModal } from './Modal_ViewAttachement_Image';
import { ConsultationDetailsModal_Customer } from './Modal_Consultaiton_Details_Customer';

export function ActiveProjectDetailModal(props) {


    let authClient_context = useContext(Auth_MerchantID_context);


    const [acctID, setAcctID ] = useState(authClient_context.acctID);
    const [schema, setSchemaName] = useState(authClient_context.schema);
    let [sessionID, setSessionID ] = useState(authClient_context.sessionID);
    let [baseURL, setBaseURL ] = useState(authClient_context.baseURL);

    let [viewEstimateDetailData, setViewEstimateDetailData] = useState([]);


    let [estimateID, setEstimateID] = useState(null);
    let [totalAmount, setTotalAmount] = useState(null);
    let [paymentType, setPaymentType] = useState(null);
    let [imageAttachement, setImageAttachement] = useState(null);
    let [viewAttachementModal, setViewAttachemntModal] = useState(false);
    let [showConsultationDetailsModal, setShowConsultationDetailsModal] = useState(false);



   //getOccupiedRoomDetailData(instant_checkInRoomID) {
    useEffect(() => {

        //alert('In Occupied Detailed Data');
        //alert(props.openModal);

        if(props.openModal == true)
        {


            const requestOptions = {
                method: 'POST',
                //credentials: 'include',
                headers: {
                    'Accept': 'text/html, application/json',
                    'content-type': 'application/json',
                    //'cookie': 'cookie',
                },
                body: JSON.stringify({
                    Tracker: '74101_view_project_details',
                    user: acctID,
                    xEstimateID: props.data.estimateID,
                    xCompanyID_public: props.data.merchantAccountID,
                    sessionID: sessionID,
    
                }),
            }

            
            fetch(baseURL+'internal_merchantAcct_argsjqApp', requestOptions)
            .then(res => res.text())
            .then(res => {

                let rows = res.toString().split('~~~');


                for (let rownum = 0; rownum < rows.length - 1; ++rownum)
                {
                    let cols = rows[rownum].split('|');

                    setEstimateID(cols[0]);

                    setViewEstimateDetailData((prevAvailableRooms) => {
                        return prevAvailableRooms.concat({
                            estimateID: cols[0],
                            merchantAccountID: cols[1],
                            customerFirstName: cols[2],
                            customerLastName: cols[3],
                            customerMobileMoneyNumber: cols[4],
                            estimateDescription: cols[5],
                            estimateLatitude: cols[6],
                            estimateLongitude: cols[7],
                            dateLogged: cols[8],
                            estimateImage1: cols[9],
                            status: cols[10],
                            consultationID: cols[11],
                            externalID: cols[12],
                            projectID: cols[13],
                            invoiceID: cols[14],
                            custoemrInvoiceID: cols[15],

                        })
                    });
                } 
            })
        }
    }, [props.openModal]);


    function conver_to_consult()
    {
        const requestOptions = {
            method: 'POST',
            //credentials: 'include',
            headers: {
                'Accept': 'text/html, application/json',
                'content-type': 'application/json',
                //'cookie': 'cookie',
            },
            body: JSON.stringify({
                Tracker: '74101_convert_to_consult',
                user: acctID,
                xEstimateID: props.data.estimateID,
                sessionID: sessionID,

            }),
        }

        
        fetch(baseURL+'userAcct_argsjqApp', requestOptions)
        .then(res => res.text())
        .then(res => {

            alert(res);
        })
    }

    function viewEstimateAttachmentHandler(event) {

        //alert('In viewEstimateInvoiceHandler');
        //alert(event);
        //alert(event[0]);
        //alert(event[3]);
        //alert(event[4]);
        //alert(event[5]);

        // setTotalAmount(event[3]);
        // setPaymentType(event[4]);
        setImageAttachement(event[1]);

        setViewAttachemntModal(event[0]);

        //setRoomID(event[1]);
        //setRoomSalePrice(event[2]);
    }

    function closeModalHandler() {

        setViewEstimateDetailData([]);
        props.closeModal(false);
    }

    return (
        <React.Fragment>
        {props.openModal == true ?
        (
        <IonModal isOpen={ props.openModal }>
        <IonHeader style={{color: 'black'}}>
            <IonGrid >
                    <IonRow>
                        <IonCol> Estimate ID</IonCol>
                        <IonCol> {props.data.estimateID} </IonCol>
                    </IonRow>
            </IonGrid>
        </IonHeader>
        <IonContent className='grid_content'>
             {viewEstimateDetailData.map((detailData) =>   {
            return (
            <IonGrid >
                <IonRow >
                    <IonCol >Category</IonCol>
                    <IonCol >Value</IonCol>
                    <IonCol >Action</IonCol>
                </IonRow>
                <IonRow >
                    <IonCol >Customer Name</IonCol>
                    <IonCol >{detailData.customerFirstName} {detailData.customerLastName}</IonCol>
                    <IonCol >
                        <IonButton > - </IonButton>
                    </IonCol>
                </IonRow>
                <IonRow >
                    <IonCol >Customer Phone</IonCol>
                    <IonCol >{detailData.customerMobileMoneyNumber}</IonCol>
                    <IonCol >
                        <IonButton > - </IonButton>
                    </IonCol>
                </IonRow>
                <IonRow >
                    <IonCol >Customer Location</IonCol>
                    <IonCol >{detailData.estimateLatitude} {detailData.estimateLongitude}</IonCol>
                    <IonCol >
                        <IonButton > View </IonButton>
                    </IonCol>
                </IonRow>
                <IonRow >
                    <IonCol >Date Logged</IonCol>
                    <IonCol >{detailData.dateLogged}</IonCol>
                    <IonCol >
                        <IonButton > - </IonButton>
                    </IonCol>
                </IonRow>
                <IonRow >
                    <IonCol >Status</IonCol>
                    <IonCol >{detailData.status}</IonCol>
                    {detailData.consultationID == 'NULL' && <IonCol > <IonText > Pending </IonText></IonCol>}
                    {detailData.consultationID != 'NULL' && <IonCol > <IonButton onClick={() => setShowConsultationDetailsModal(true)}> View </IonButton></IonCol>}


                    {showConsultationDetailsModal == true && <ConsultationDetailsModal_Customer openModal={ showConsultationDetailsModal } closeModal={() => setShowConsultationDetailsModal(false)} data={{
                                        status: 'ACTIVE_PROJECT',
                                        consultationID: detailData.consultationID, 
                                        merchantAccountID: detailData.merchantAccountID,
                                        mtnCompanyPhoneNumber: detailData.customerMobileMoneyNumber, 
                                        firstName: detailData.customerFirstName, 
                                        lastName: detailData.customerLastName,
                                        mobileNumber: detailData.customerMobileMoneyNumber,
                                        cartLatitude: detailData.estimateLatitude,
                                        cartLongitude: detailData.estimateLongitude,
                                        externalID: detailData.externalID,
                                        projectID: detailData.projectID,
                                        invoiceID: detailData.invoiceID,
                                        customerInvoiceID: detailData.custoemrInvoiceID,

                                        }}></ConsultationDetailsModal_Customer>}
                </IonRow>
                <IonRow >
                    <IonCol >Description</IonCol>
                    <IonCol style={{fontSize: 'small'}}>
                        <textarea cols="50" rows="10" value={detailData.estimateDescription} placeholder='Request Description' required></textarea>
                    </IonCol>
                    <IonCol >
                        <IonButton > - </IonButton>
                    </IonCol>
                </IonRow>
                <IonRow >
                    <IonCol >Attachment</IonCol>
                    <IonCol >{'Estimate Attachment'}</IonCol>
                    <IonCol >
                        <ViewAttachement_ImageModal openModal={ viewAttachementModal } closeModal={() => setViewAttachemntModal(false)} data={{
                                                fileLocation: detailData.attachment, 
                                                }}></ViewAttachement_ImageModal>

                        <IonButton className='appListButton' onClick={() => viewEstimateAttachmentHandler([true, detailData.attachment])}> View </IonButton>

                    </IonCol>
                </IonRow>
            </IonGrid>
                    )
                }
            )}
   </IonContent>
        <IonFooter className='grid_footer'>
            <IonButton onClick={closeModalHandler}> Close </IonButton>
        </IonFooter>

    </IonModal>) : null}
    </React.Fragment>
    )
}